import * as Sentry from '@sentry/vue'
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import fbApp  from "../../../firebaseInstance"


export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const { public: { sentry } } = useRuntimeConfig()


  // dev และ localhost ไม่ส่งขึ้น Sentry เว้นแต่ตั้ง SENTRY_DEV=true (ดู nuxt.config.ts)
  //
  // ต้องดู hostname ด้วย ไม่ใช่แค่ NODE_ENV เพราะ `nuxt generate` แล้ว serve ดูในเครื่อง
  // ก็เป็น production build เหมือนกัน ถ้าเช็คแค่ NODE_ENV มันจะยิงขึ้นของจริงเงียบ ๆ
  const isProductionBuild = process.env.NODE_ENV === 'production'
  const isLocalhost = ['localhost', '127.0.0.1', '[::1]'].includes(location.hostname)
  const enabled = sentry.forceEnable || (isProductionBuild && !isLocalhost)

  if (!sentry.dsn || !enabled) {
    return
  }

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: sentry.dsn,
    environment: sentry.environment,
    // ชื่อ release คิดตอน build แยก beta / production ให้แล้ว (ดู sentryRelease.mjs)
    release: sentry.release,
    // เปิด log ของ Sentry เองตอนทดสอบ จะได้เห็นใน console ว่าส่งจริงไหม
    debug: !isProductionBuild,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    //tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    // ไม่สุ่มอัด replay ปกติ POS เปิดค้างทั้งวัน ถ้าสุ่มจะส่ง envelope ตลอดและกินโควต้า replay
    // ยังเก็บ buffer ในเครื่องไว้ ส่งขึ้นเฉพาะตอนเกิด error (ดู replaysOnErrorSampleRate)
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // หน้า /login-with-token รับ custom token มาใน URL (#token=...) Sentry เริ่มทำงานก่อนหน้านั้น
    // จะลบ hash ทัน ตัด token ออกจาก URL ใน event และ breadcrumb ไม่ให้หลุดขึ้น Sentry
    beforeSend(event) {
      if (event.request?.url) event.request.url = redactToken(event.request.url)
      return event
    },
    beforeBreadcrumb(breadcrumb) {
      const data = breadcrumb.data
      if (data?.from) data.from = redactToken(data.from)
      if (data?.to) data.to = redactToken(data.to)
      if (data?.url) data.url = redactToken(data.url)
      return breadcrumb
    },
  })

  //SET USER
  const auth = getAuth(fbApp.app);
  const shopStore = useShopStore()

  watch(()=> shopStore.storeId, (a,b) => { 
    onAuthStateChanged(auth,(user) => {
      if (user) {             
        Sentry.setUser({
          id: shopStore.storeId,
          username: `${user.email}`,         
        })
      } else {
      }
    });
})  

})

function redactToken(url: string) {
  return String(url).replace(/([#?&]token=)[^&#]*/g, "$1[redacted]")
}
